import React, { useState } from 'react';
import axios from 'axios';

const ModalCreateClient = ({ isVisible, onClose, listServer }) => {

    const [values, setValues] = useState({
        nom: '',
        nb_ecrans: '',
        serveur:'',
        date_pose:'',
        date_limite:'',
        color:'',
        remarque:'',
        limit_notif:'false'

    })

    const handleClose = (e) => {  if(e.target.id === "wrapper") onClose(); }
    const handleSubmit = (e) => {
        e.preventDefault();
        let error = document.getElementById('error');
        error.innerHTML = '';

        if(values.nom === '' || values.date_pose === '' || values.date_limite === '' || values.nb_ecrans === ''){
            error.innerHTML = "Veuillez renseigner tout les champs"
        }else{
           
            // axios.post(`${process.env.REACT_APP_IP3}:${process.env.REACT_APP_PORT4}/add_client`, values)
            axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/add_client`, values)
            .then(res => {
                // console.log(res);
                // navigate('/listusers');
                window.location.reload(false);
            }).catch(err => console.log(err))
        }
    }

    // console.log(listServer);

    if( !isVisible ) return null;

    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4' id="wrapper" onClick={handleClose}>
            <div className='bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto'>
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Nouveau client</h2>
                    <button type="button" className='flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600' onClick={() => onClose()}>✕</button>
                </div>
                <form className="p-6" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="nom" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom</label>
                        <input type="text" name="nom" id="nom" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Nom" required  onChange={e => setValues({...values, nom: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="nb_ecrans" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nombre d'écrans</label>
                        <input type="text" name="nb_ecrans" id="nb_ecrans" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Nombre d'écrans" required  onChange={e => setValues({...values, nb_ecrans: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="date_pose" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Date de pose</label>
                        <input type="date" name="date_pose" id="date_pose" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required  onChange={e => setValues({...values, date_pose: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="date_limite" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Date limite</label>
                        <input type="date" name="date_limite" id="date_limite" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required  onChange={e => setValues({...values, date_limite: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="serveur" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Serveur</label>
                        <select id="serveur" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" onChange={e => setValues({...values, serveur: e.target.value})} >
                        <option selected>Choisissez un Server</option>
                            {
                                listServer.map((server) => (
                                   <option value={server.id} >{server.nom_serveur}</option>

                                ))
                            }
                        </select>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="remarque" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Remarque (optionnel)</label>
                        <textarea name="remarque" id="remarque" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Remarque (optionnel)"  onChange={e => setValues({...values, remarque: e.target.value})}/>
                    </div>
                    <button type="submit" className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCreateClient;